module.exports = __webpack_public_path__ + "media/svg/td-1e912db2.svg";